import { createAction } from 'redux-actions'

export const copyToClipboard = createAction('COPY_TO_CLIPBOARD', content => content, (content, opts) => opts)
